import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ClubInfoBox from '../../components/club/ClubInfoBox';
import ClubActivitySection from '../../components/club/ClubActivitySection';
import BackButton from '../../components/common/BackButton';

import './ClubDetailPage.css'

// 동아리 상세 페이지 컴포넌트
export default function ClubDetailPage() {
    // URL에서 동아리 id 추출
    const { id } = useParams();

    // 동아리 삭제 여부
    const [isDeleted, setIsDeleted] = useState(false);

    const navigate = useNavigate();

    // 삭제된 동아리일 경우 메인 페이지로 이동
    if (isDeleted) {
        navigate("/");
        return alert("삭제된 동아리 입니다.");
    }

    return (
        <>
            {/* 뒤로가기 버튼 */}
            <BackButton />

            {/* 동아리 기본 정보 */}
            <ClubInfoBox clubId={id} onDelete={() => setIsDeleted(true)} />

            {/* 동아리 주요 활동 */}
            <ClubActivitySection clubId={id} />
        </>
    );
}